import { Provider } from "@redotech/redo-order-common/provider";
import * as z from "zod";

export const recognizeRunFilters = z.object({
  excludeZeroValueOrders: z.boolean().default(false),
  excludedOrderTags: z.array(z.string().trim().min(1)).default([]),
  excludedSources: z.array(z.nativeEnum(Provider)),
  excludedSalesChannels: z.array(z.string().trim().min(1)).default([]),
});

export type RecognizeRunFilters = z.infer<typeof recognizeRunFilters>;

export function shouldRunRecognize(
  provider: Provider,
  filters: RecognizeRunFilters,
  salesChannel: string | null | undefined,
  totalPrice: string | undefined,
  tags: readonly string[],
): boolean {
  if (filters.excludedSources.includes(provider)) {
    return false;
  }

  const isZeroValueOrder =
    filters.excludeZeroValueOrders &&
    totalPrice !== undefined &&
    totalPrice.trim() !== "" &&
    Number(totalPrice) === 0;
  if (isZeroValueOrder) {
    return false;
  }

  const normalizedTags = new Set(tags.map((tag) => tag.trim().toLowerCase()));
  const hasExcludedTag = filters.excludedOrderTags.some((tag) =>
    normalizedTags.has(tag.trim().toLowerCase()),
  );
  if (hasExcludedTag) {
    return false;
  }

  if (!salesChannel) {
    return true;
  }
  const normalizedChannel = salesChannel.trim().toLowerCase();
  return !filters.excludedSalesChannels.some(
    (channel) => channel.trim().toLowerCase() === normalizedChannel,
  );
}
